import { MAP_IDENTITY_DOCUMENT_TYPE } from '../../../constraints';

export const getIdentityPlaceHolderId = (isDiploma) => {
  if (isDiploma) {
    return MAP_IDENTITY_DOCUMENT_TYPE.INDEX_NUMBER;
  }
  return MAP_IDENTITY_DOCUMENT_TYPE.UNASSIGNED;
};
